<template>
  <standard-layout header="Operations-Modus">
    <template v-slot:main>
      <div class="row">
        <div class="col-12 col-md-6">
          <operating-mode-calendar
              :selected-date="selectedDate"
              @dayclick="dateSelected($event)"
              :updated="lastUpdate"/>
        </div>
      </div>
      <div class="h4 mt-4">
        <span v-if="selectedDate">{{ selectedDate | date }}</span>
        <span v-else class="text-secondary">bitte Datum wählen</span>
      </div>
      <div v-if="selectedDate" class="mt-3">
        <div class="h5">Modus für diesen Tag</div>
        <div class="btn-group" role="group">
          <button
              v-for="mode in modes"
              :key="mode"
              class="btn"
              :class="currentMode === mode ? 'btn-primary' : 'btn-outline-primary'"
              @click="setMode(mode)">
            {{ mode }}
          </button>
        </div>
        <button v-if="currentMode"
                class="btn btn-outline-danger btn-sm ml-3"
                @click="clearMode">
          Zurücksetzen
        </button>
        <div class="form-check mt-3">
          <input
              id="silentChange"
              type="checkbox"
              class="form-check-input"
              v-model="silent">
          <label class="form-check-label" for="silentChange">
            stille Änderung (keine Benachrichtigung an Abonnenten)
          </label>
        </div>
      </div>
    </template>
  </standard-layout>
</template>

<script>
import StandardLayout from "@/layouts/StandardLayout";
import OperatingModeCalendar from "@/components/erp/OperatingModeCalendar";
import {DateTime} from "luxon";

export default {
  data() {
    return {
      selectedDate: null,
      currentMode: null,
      lastUpdate: null,
      modes: [],
      silent: false
    }
  },
  methods: {
    dateSelected(dayObject) {
      this.selectedDate = DateTime.local(dayObject.year, dayObject.month, dayObject.day, 0)
      this.loadMode()
    },
    loadModes() {
      this.$api.get('/calendar/operating-days/modes')
          .then(response => this.modes = response.data)
          .catch(err => this.handleError(err))
    },
    loadMode() {
      const {year, month, day} = this.selectedDate
      this.$api.get(`/calendar/operating-days/${year}/${month}/${day}`)
          .then(response => this.currentMode = response.data)
          .catch(err => this.handleError(err))
    },
    setMode(mode) {
      const {year, month, day} = this.selectedDate
      const silent = this.silent
      this.$api.put(`/calendar/operating-days/${year}/${month}/${day}`, {mode, silent})
          .then(() => {
            this.currentMode = mode
            this.lastUpdate = Date.now()
            this.silent = false
            const suffix = silent ? ' (still)' : ''
            this.showInfo(`Modus für ${this.selectedDate.toFormat('dd.MM.yy')} auf "${mode}" gesetzt${suffix}.`)
          })
          .catch(err => this.handleError(err))
    },
    clearMode() {
      const {year, month, day} = this.selectedDate
      this.$api.delete(`/calendar/operating-days/${year}/${month}/${day}`)
          .then(() => {
            this.currentMode = null
            this.lastUpdate = Date.now()
            this.silent = false
            this.showInfo(`Modus für ${this.selectedDate.toFormat('dd.MM.yy')} zurückgesetzt.`)
          })
          .catch(err => this.handleError(err))
    }
  },
  mounted() {
    this.loadModes()
  },
  components: {
    StandardLayout,
    OperatingModeCalendar
  }
}
</script>